import React from 'react';
import { SubscriptionLayout } from '../components/SubscriptionLayout';
import { Invoices } from '../components/Invoices';

export const InvoicesPage = () => {
  return (
    <SubscriptionLayout activeTab="invoices">
      <Invoices />
    </SubscriptionLayout>
  );
};
